import { Version } from '@wix/ambassador-stores-catalog-v3-provision/types';
import { fetchProductV1 } from './fetch-products-v1';
import { fetchProductV3 } from './fetch-products-v3';
export const fetchProductPages = async (httpClient, errorHandler, catalogVersion, ids) => {
  return catalogVersion === Version.V1_CATALOG ? fetchProductV1(httpClient, errorHandler, ids) : fetchProductV3(httpClient, errorHandler, ids);
};
//# sourceMappingURL=fetch-products.js.map